import React, { useState, useEffect, useRef } from "react";
import { Button, Image, Table, Space, Input, Select } from "antd";
import { request } from "../../../functions/request";
import dayjs from "dayjs";
import { Content } from "antd/es/layout/layout";
import { useSearchParams } from "react-router-dom";
import { editoriaOpcoes } from "../../../constants/constants";
const { Search } = Input;

function formatData(dataArray) {
  let arrayData = [];
  let dataContent = Array.isArray(dataArray[0]) ? dataArray[0] : dataArray;

  if (
    typeof dataContent === "object" &&
    dataContent !== null &&
    !Array.isArray(dataContent)
  ) {
    const aux = [];
    for (const key in dataContent) {
      if (Array.isArray(dataContent[key]) && dataContent[key].length > 0) {
        dataContent[key][0].map((data) => {
          aux.push(data);
        });
      }
    }
    dataContent = aux;
  }

  if (!dataContent || dataContent === undefined) return dataContent;

  dataContent.map((data) => {
    arrayData.push({
      key: data.img_codigo,
      img_nome: data.img_nome,
      img_comentario: data.img_comentario,
      img_arquivo: data.img_arquivo,
      img_data: dayjs(data.img_data).format("DD/MM/YYYY HH:mm:ss"),
    });
  });
  return arrayData;
}

const pesquisaOpcoes = [
  { value: "img_nome", label: "Legenda" },
  { value: "img_comentario", label: "Comentário" },
];

const ULTIMA_BUSCA_KEY = "bancoImagens_ultimaBusca";

function loadUltimaBusca() {
  try {
    const raw = localStorage.getItem(ULTIMA_BUSCA_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    return parsed && typeof parsed === "object" ? parsed : null;
  } catch (err) {
    return null;
  }
}

export default function BancoImagensPopUp() {
  const ultimaBusca = loadUltimaBusca();
  const [imagensData, setImagensData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [search, setSearch] = useState({
    filter: ultimaBusca?.filter || "",
    textSearchType: ultimaBusca?.textSearchType || "img_comentario",
    searchText: ultimaBusca?.searchText || "",
  });
  const [currentPage, setCurrentPage] = useState(1);
  const tableRef = useRef(null);
  const [URLSearchParams, SetURLSearchParams] = useSearchParams();
  const pageSize =
    parseInt(URLSearchParams.get("pageSize")) ||
    parseInt(localStorage.getItem("pageSize")) ||
    10;

  const runSearch = async (value, activeSearch) => {
    let currentPathWithQuery = `/imagem/getImagemWithFilter?`;

    if (value === "" && activeSearch.filter === "") {
      currentPathWithQuery = `/imagem/getLastImagens`;
    } else {
      // Filtra pela coluna img_editoria (indexada) em vez do prefixo do nome
      // do arquivo. O valor guardado em activeSearch.filter é o mesmo código
      // ("gf01"), então a busca salva no localStorage continua válida.
      currentPathWithQuery += `img_nome=${
        activeSearch.textSearchType === "img_nome" ? value : ""
      }&img_comentario=${
        activeSearch.textSearchType === "img_comentario" ? value : ""
      }&img_editoria=${activeSearch.filter}`;
    }

    setSearch((prevState) => ({ ...prevState, searchText: value }));
    try {
      localStorage.setItem(
        ULTIMA_BUSCA_KEY,
        JSON.stringify({ ...activeSearch, searchText: value })
      );
    } catch (err) {
      // localStorage indisponível (modo privado etc.) — não é crítico, só
      // significa que a próxima abertura não vai lembrar essa busca.
    }

    setIsLoading(true);
    await request(currentPathWithQuery, {
      method: "GET",
    })
      .then((response) => {
        const data = formatData(response);
        setImagensData(data);
      })
      .finally(() => {
        scrollTop();
        setCurrentPage(1);
        setIsLoading(false);
      });
  };

  // antd Input.Search chama onSearch(value, event, info) — não repassar o
  // event adiante, sempre usa o `search` atual do state.
  const onSearch = (value) => runSearch(value, search);

  const columns = [
    {
      title: "Imagem",
      dataIndex: "img_arquivo",
      render: (text) => (
        <Image
          style={{
            height: "100%",
            aspectRatio: "16 / 9",
            objectFit: "cover",
          }}
          preview={{ height: "50%" }}
          src={`${process.env.REACT_APP_BANCO_IMG_URL}${text}`}
        />
      ),
    },
    {
      title: "Nome",
      dataIndex: "img_nome",
    },
    {
      title: "Comentário",
      dataIndex: "img_comentario",
    },

    {
      title: "Data",
      dataIndex: "img_data",
    },
    {
      title: "",
      key: "action",
      render: (_, record) => (
        <Button type="primary" onClick={() => handleChoose(record)}>
          Escolher
        </Button>
      ),
    },
  ];

  const handleChoose = (record) => {
    console.log("Escolheu:", record);
    if (window.opener) {
      var parentWindow = window.opener;
      parentWindow.onChooseImage(record);
    }
  };

  useEffect(() => {
    // Se tem uma busca anterior salva (filtro de editoria e/ou texto),
    // reaplica ela direto ao abrir o pop-up em vez de mostrar só as últimas
    // imagens — evita ter que refazer a mesma busca toda vez.
    if (ultimaBusca && (ultimaBusca.filter || ultimaBusca.searchText)) {
      runSearch(ultimaBusca.searchText || "", ultimaBusca);
      return;
    }

    async function getData() {
      setIsLoading(true);
      const currentPathWithQuery = `/imagem/getLastImagens`;
      console.log(currentPathWithQuery);
      const response = await request(currentPathWithQuery, {
        method: "GET",
      });
      const data = formatData(response);
      console.log(data);
      setImagensData(data);
      setIsLoading(false);
    }
    getData();
  }, []);

  function scrollTop() {
    return window.scrollTo(0, 0);
  }

  return (
    <>
      <div ref={tableRef} style={{ width: "100%", padding: 10 }}>
        <Space direction="horizontal" size={"middle"}>
          <Space.Compact>
            <Select
              title="Filtro"
              placeholder={"Filtrar por editoria"}
              options={editoriaOpcoes}
              allowClear
              value={search.filter || undefined}
              onSelect={(value) =>
                setSearch((prevState) => ({
                  ...prevState,
                  filter: value,
                }))
              }
              onClear={() =>
                setSearch((prevState) => ({
                  ...prevState,
                  filter: "",
                }))
              }
            />
          </Space.Compact>

          <Space.Compact>
            <Search
              placeholder="Pesquisar..."
              defaultValue={search.searchText}
              onSearch={onSearch}
              addonBefore={
                <Select
                  value={search.textSearchType || undefined}
                  options={pesquisaOpcoes}
                  onSelect={(value) =>
                    setSearch((prevState) => ({
                      ...prevState,
                      textSearchType: value,
                    }))
                  }
                  onClear={() =>
                    setSearch((prevState) => ({
                      ...prevState,
                      textSearchType: "",
                    }))
                  }
                />
              }
            />
          </Space.Compact>
        </Space>
        <Content>
          <Table
            scroll={{ scrollToFirstRowOnChange: true }}
            columns={columns}
            dataSource={imagensData}
            tableLayout="auto"
            pagination={{
              position: ["topLeft", "bottomLeft"],
              pageSize: pageSize,
              current: parseInt(URLSearchParams.get("page")) || undefined,
              onChange: (page, pageSize) => {
                if (pageSize) {
                  localStorage.setItem("pageSize", pageSize.toString());
                }
                SetURLSearchParams({ pageSize: pageSize, page: page });
                scrollTop();
              },
            }}
            size="large"
            loading={isLoading}
          />
        </Content>
      </div>
    </>
  );
}
